<template>
  <v-data-table
    :headers="headers"
    :items="turmas"

    :sort-desc="true"

    class="elevation-1"
    :search="search"
  >

    <template v-slot:top>
      <v-toolbar flat color="white">
         <v-progress-circular
                        :size="50"
                        color="green"
                        indeterminate
                         v-if="isLoading"
                      ></v-progress-circular>
        <v-btn
          to="/menu-pautaTrimestral"
          class="mx-2"
          fab
          dark
          color="primary"
        >
          <v-icon dark>arrow_back</v-icon>
        </v-btn>

        <v-divider class="mx-8" inset vertical></v-divider>
        <v-toolbar-title>
          Turma(s) da
          <span v-if="idclasse === 1">10ª classe</span>
          <span v-if="idclasse === 2">11ª classe</span>
          <span v-if="idclasse === 3">12ª classe</span>
          <span v-if="idclasse === 4">13ª classe</span>
        </v-toolbar-title>
        <v-divider class="mx-8" inset vertical></v-divider>
             <span>Selecionado : <strong style="font-size:22px;">{{$store.state.novadescricaoSelecionado}}</strong></span>
        <!--  search  -->
        <div v-if="$store.state.hasMessage" :class="$store.state.classMessage">
          {{ $store.state.textMessage }}
        </div>

        <div class="flex-grow-1"></div>

        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
        <!-- end  search  -->

        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="500px">

          <v-card>
            <v-card-title>
              <span v-if="idclasse === 1">10ª classe</span>
              <span v-if="idclasse === 2">11ª classe</span>
              <span v-if="idclasse === 3">12ª classe</span>
              <span v-if="idclasse === 4">13ª classe</span>
            </v-card-title>

           </v-card>
        </v-dialog>
        <div>
    <v-row justify="center">
    <v-dialog v-model="trimestreDialog" persistent max-width="390">
      <v-card>
        <v-card-title class="headline">Selecione o Trimestre desejado</v-card-title>
         <v-col
            cols="12"
            md="12"
          >
            <v-select
              v-model="trimestre"
              item-value="idTrimestre"
              item-text="descricao"
              :items="trimestres"
              :disabled="isUpdating"
               filled
              color="blue-grey lighten-2"
              label="Trimestre"
              return-object
            ></v-select>
          </v-col>
           <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="trimestreDialog=false">Cancelar</v-btn>
           <v-btn color="green darken-1" text @click="trimestreEscolhido()">Concordar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
  </div>
      </v-toolbar>
    </template>
    <template v-slot:item.action="{ item }">
        <v-icon  class="mr-2" @click=" OpenDialogTrimestre(item) "  style="color:green">print</v-icon>

    </template>
    <template v-slot:no-data>
      no data
    </template>
  </v-data-table>
</template>
<script>
import axios from '../../../../../plugins/axios'
const help = require('../../../../../../Helpers/Helpers')
const ls = require('local-storage')
export default {
  data: () => ({
    logotipo: ls.get('insignia'),
    option: { 'format': 'A3',
      'orientation': 'landscape',
      paginationOffset: 2,
      'header': {
        'height': '10mm',
        'contents': '<div style="text-align: center;"></div>' },
      'footer': {
        'height': '5mm'
      } },
    trimestreDialog: false,
    trimestre: 0,
    trimestres: [{
      idTrimestre: 1,
      descricao: '1º Trimestre',
      trimestre: 'Iº Trimestre'
    },
    {
      idTrimestre: 2,
      descricao: '2º Trimestre',
      trimestre: 'IIº Trimestre'
    }
    ],
    isUpdating: false,
    url: ``,
    text: '',
    flag_curso: '',
    formValid: true,
    alunosTurma: [],
    flag_periodo: '',
    flag_sala: '',
    flag_class: '',
    sala: '',
    search: '',
    quant: 0,
    cursos: [],
    html: ``,
    disciplinas: [],
    notas: [],
    isLoading: false,
    turmas: [],
    turma: {},
    dialog: false,
    headers: [
      {
        text: 'descricao',
        align: 'left',
        sortable: false,
        value: 'turmadescricao'
      },
      { text: 'Periodo', value: 'periodo' },
      { text: 'Curso', value: 'curso' },
      { text: 'Numero de Alunos', value: 'quantalunos' },
      { text: 'Modificado', value: 'data_2' },
      { text: 'Acção', value: 'action', sortable: false }
    ]

  }),

  computed: {
    idclasse () {
      return this.$store.state.idclasse
    },
    classeTur () {
      return this.$store.state.classeTur
    },
    instituicaodescricao () {
      return ls.get('instituicaodescricao')
    },

    instituicaoId () {
      return ls.get('i_id')
    }

  },

  watch: {
    dialog (val) {
      val || this.close()
    }
  },

  created () {
    // check if classe has been selected otherwise send back to painel to select
    this.initializeturmasAll()
    this.carregarConfiguracoesReports()
  },

  methods: {
    OpenDialogTrimestre (dadosTurma) {
      this.trimestreDialog = true
      this.turma = dadosTurma
    },

    descricaoEscola () {
      return (this.instituicaoId === 1) ? 'INSTITUTO TÉCNICO DE SAÚDE DE LUANDA' : this.instituicaodescricao.toUpperCase()
    },

    getClasseDescricao (idclasse) {
      switch (idclasse) {
        case 1:
          return '10ª Classe'
        case 2:
          return '11ª Classe'
        case 3:
          return '12ª Classe'
        case 4:
          return '13ª Classe'

        default:
          break
      }
    },

    trimestreEscolhido () {
      this.trimestreDialog = false
      if (this.trimestre.idTrimestre === 1) this.carregarNotasPrimeiroTrimestre()
      else
      if (this.trimestre.idTrimestre === 2) this.carregarNotasSegundoTrimestre()
    },
    async carregarNotasPrimeiroTrimestre () {
      this.isLoading = true
      const valor = {
        turma: this.turma.pkTurma,
        ano: this.turma.idAno_Academico
      }
      let camposPauta = {}

      try {
        this.disciplinas = await axios
          .post('/discipautageral', valor)
          .then(res => res.data)
        if (this.disciplinas.length > 0) this.disciplinas = this.disciplinas[0]
        if (this.disciplinas.length === 4) {
          camposPauta = {
            turma: this.disciplinas[0].pkTurma,
            ano: this.disciplinas[0].anoLectivo,
            d0: this.disciplinas[0].iddisciplina,
            d1: this.disciplinas[1].iddisciplina,
            d2: this.disciplinas[2].iddisciplina,
            d3: this.disciplinas[3].iddisciplina,
            quant: 4
          }
        } else
        if (this.disciplinas.length === 8) {
          camposPauta = {
            turma: this.disciplinas[0].pkTurma,
            ano: this.disciplinas[0].anoLectivo,
            d0: this.disciplinas[0].iddisciplina,
            d1: this.disciplinas[1].iddisciplina,
            d2: this.disciplinas[2].iddisciplina,
            d3: this.disciplinas[3].iddisciplina,
            d4: this.disciplinas[4].iddisciplina,
            d5: this.disciplinas[5].iddisciplina,
            d6: this.disciplinas[6].iddisciplina,
            d7: this.disciplinas[7].iddisciplina,
            quant: 8
          }
        } else
        if (this.disciplinas.length === 9) {
          camposPauta = {
            turma: this.disciplinas[0].pkTurma,
            ano: this.disciplinas[0].anoLectivo,
            d0: this.disciplinas[0].iddisciplina,
            d1: this.disciplinas[1].iddisciplina,
            d2: this.disciplinas[2].iddisciplina,
            d3: this.disciplinas[3].iddisciplina,
            d4: this.disciplinas[4].iddisciplina,
            d5: this.disciplinas[5].iddisciplina,
            d6: this.disciplinas[6].iddisciplina,
            d7: this.disciplinas[7].iddisciplina,
            d8: this.disciplinas[8].iddisciplina,
            quant: 9
          }
        } else
        if (this.disciplinas.length === 10) {
          camposPauta = {
            turma: this.disciplinas[0].pkTurma,
            ano: this.disciplinas[0].anoLectivo,
            d0: this.disciplinas[0].iddisciplina,
            d1: this.disciplinas[1].iddisciplina,
            d2: this.disciplinas[2].iddisciplina,
            d3: this.disciplinas[3].iddisciplina,
            d4: this.disciplinas[4].iddisciplina,
            d5: this.disciplinas[5].iddisciplina,
            d6: this.disciplinas[6].iddisciplina,
            d7: this.disciplinas[7].iddisciplina,
            d8: this.disciplinas[8].iddisciplina,
            d9: this.disciplinas[9].iddisciplina,
            quant: 10
          }
        } else
        if (this.disciplinas.length === 11) {
          camposPauta = {
            turma: this.disciplinas[0].pkTurma,
            ano: this.disciplinas[0].anoLectivo,
            d0: this.disciplinas[0].iddisciplina,
            d1: this.disciplinas[1].iddisciplina,
            d2: this.disciplinas[2].iddisciplina,
            d3: this.disciplinas[3].iddisciplina,
            d4: this.disciplinas[4].iddisciplina,
            d5: this.disciplinas[5].iddisciplina,
            d6: this.disciplinas[6].iddisciplina,
            d7: this.disciplinas[7].iddisciplina,
            d8: this.disciplinas[8].iddisciplina,
            d9: this.disciplinas[9].iddisciplina,
            d10: this.disciplinas[10].iddisciplina,
            quant: 11
          }
        } else
        if (this.disciplinas.length === 12) {
          camposPauta = {
            turma: this.disciplinas[0].pkTurma,
            ano: this.disciplinas[0].anoLectivo,
            d0: this.disciplinas[0].iddisciplina,
            d1: this.disciplinas[1].iddisciplina,
            d2: this.disciplinas[2].iddisciplina,
            d3: this.disciplinas[3].iddisciplina,
            d4: this.disciplinas[4].iddisciplina,
            d5: this.disciplinas[5].iddisciplina,
            d6: this.disciplinas[6].iddisciplina,
            d7: this.disciplinas[7].iddisciplina,
            d8: this.disciplinas[8].iddisciplina,
            d9: this.disciplinas[9].iddisciplina,
            d10: this.disciplinas[10].iddisciplina,
            d11: this.disciplinas[10].iddisciplina,
            quant: 12
          }
        }
        this.notas = await axios
          .post('/pautaPrimeiroTimestre', camposPauta)
          .then(res => res.data)
        if (this.disciplinas.length === 8) { this.comporHtmlPauta8(this.disciplinas, this.notas) } else
        if (this.disciplinas.length === 9) { this.comporHtmlPauta9(this.disciplinas, this.notas) } else
        if (this.disciplinas.length === 10) { this.comporHtmlPauta10(this.disciplinas, this.notas) } else
        if (this.disciplinas.length === 11) { this.comporHtmlPauta11(this.disciplinas, this.notas) } else
        if (this.disciplinas.length === 12) { this.comporHtmlPauta12(this.disciplinas, this.notas) }
      } catch (error) {
        this.isLoading = false
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },
    async carregarNotasSegundoTrimestre () {
      this.isLoading = true
      const valor = {
        turma: this.turma.pkTurma,
        ano: this.turma.idAno_Academico
      }
      let camposPauta = {}

      try {
        this.disciplinas = await axios
          .post('/discipautageral', valor)
          .then(res => res.data)
        if (this.disciplinas.length > 0) this.disciplinas = this.disciplinas[0]
        if (this.disciplinas.length === 4) {
          camposPauta = {
            turma: this.disciplinas[0].pkTurma,
            ano: this.disciplinas[0].anoLectivo,
            d0: this.disciplinas[0].iddisciplina,
            d1: this.disciplinas[1].iddisciplina,
            d2: this.disciplinas[2].iddisciplina,
            d3: this.disciplinas[3].iddisciplina,
            quant: 4
          }
        } else
        if (this.disciplinas.length === 8) {
          camposPauta = {
            turma: this.disciplinas[0].pkTurma,
            ano: this.disciplinas[0].anoLectivo,
            d0: this.disciplinas[0].iddisciplina,
            d1: this.disciplinas[1].iddisciplina,
            d2: this.disciplinas[2].iddisciplina,
            d3: this.disciplinas[3].iddisciplina,
            d4: this.disciplinas[4].iddisciplina,
            d5: this.disciplinas[5].iddisciplina,
            d6: this.disciplinas[6].iddisciplina,
            d7: this.disciplinas[7].iddisciplina,
            quant: 8
          }
        } else
        if (this.disciplinas.length === 9) {
          camposPauta = {
            turma: this.disciplinas[0].pkTurma,
            ano: this.disciplinas[0].anoLectivo,
            d0: this.disciplinas[0].iddisciplina,
            d1: this.disciplinas[1].iddisciplina,
            d2: this.disciplinas[2].iddisciplina,
            d3: this.disciplinas[3].iddisciplina,
            d4: this.disciplinas[4].iddisciplina,
            d5: this.disciplinas[5].iddisciplina,
            d6: this.disciplinas[6].iddisciplina,
            d7: this.disciplinas[7].iddisciplina,
            d8: this.disciplinas[8].iddisciplina,
            quant: 9
          }
        } else
        if (this.disciplinas.length === 10) {
          camposPauta = {
            turma: this.disciplinas[0].pkTurma,
            ano: this.disciplinas[0].anoLectivo,
            d0: this.disciplinas[0].iddisciplina,
            d1: this.disciplinas[1].iddisciplina,
            d2: this.disciplinas[2].iddisciplina,
            d3: this.disciplinas[3].iddisciplina,
            d4: this.disciplinas[4].iddisciplina,
            d5: this.disciplinas[5].iddisciplina,
            d6: this.disciplinas[6].iddisciplina,
            d7: this.disciplinas[7].iddisciplina,
            d8: this.disciplinas[8].iddisciplina,
            d9: this.disciplinas[9].iddisciplina,
            quant: 10
          }
        } else
        if (this.disciplinas.length === 11) {
          camposPauta = {
            turma: this.disciplinas[0].pkTurma,
            ano: this.disciplinas[0].anoLectivo,
            d0: this.disciplinas[0].iddisciplina,
            d1: this.disciplinas[1].iddisciplina,
            d2: this.disciplinas[2].iddisciplina,
            d3: this.disciplinas[3].iddisciplina,
            d4: this.disciplinas[4].iddisciplina,
            d5: this.disciplinas[5].iddisciplina,
            d6: this.disciplinas[6].iddisciplina,
            d7: this.disciplinas[7].iddisciplina,
            d8: this.disciplinas[8].iddisciplina,
            d9: this.disciplinas[9].iddisciplina,
            d10: this.disciplinas[10].iddisciplina,
            quant: 11
          }
        } else
        if (this.disciplinas.length === 12) {
          camposPauta = {
            turma: this.disciplinas[0].pkTurma,
            ano: this.disciplinas[0].anoLectivo,
            d0: this.disciplinas[0].iddisciplina,
            d1: this.disciplinas[1].iddisciplina,
            d2: this.disciplinas[2].iddisciplina,
            d3: this.disciplinas[3].iddisciplina,
            d4: this.disciplinas[4].iddisciplina,
            d5: this.disciplinas[5].iddisciplina,
            d6: this.disciplinas[6].iddisciplina,
            d7: this.disciplinas[7].iddisciplina,
            d8: this.disciplinas[8].iddisciplina,
            d9: this.disciplinas[9].iddisciplina,
            d10: this.disciplinas[10].iddisciplina,
            d11: this.disciplinas[10].iddisciplina,
            quant: 12
          }
        }
        this.notas = await axios
          .post('/pautaSegundoTimestre', camposPauta)
          .then(res => res.data)
        if (this.disciplinas.length === 8) { this.comporHtmlPauta8(this.disciplinas, this.notas) } else
        if (this.disciplinas.length === 9) { this.comporHtmlPauta9(this.disciplinas, this.notas) } else
        if (this.disciplinas.length === 10) { this.comporHtmlPauta10(this.disciplinas, this.notas) } else
        if (this.disciplinas.length === 11) { this.comporHtmlPauta11(this.disciplinas, this.notas) } else
        if (this.disciplinas.length === 12) { this.comporHtmlPauta12(this.disciplinas, this.notas) }
      } catch (error) {
        this.isLoading = false
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },
    async initializeturmasAll () {
      try {
        this.isLoading = true
        this.turmas = await axios
          .get('/turmaFindAll-Anolectivo/' + this.$store.state.anolectivoSelecionado + '/' + this.$store.state.idclasse)
          .then(res => res.data)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },

    ListagemEstudantes (item) {
      this.$store.state.objturma = item
      this.$router.push('ListaAlunos')
    },
    zebraPauta (i) {
      if (i % 2) {
        return 'zebr'
      } else {
        return ''
      }
    },
    async  pautasgerarpdf (options) {
      this.isLoading = true
      try {
        await axios({
          method: 'post',
          url: ls.get('urlReport') + 'writefile', //  http://localhost:8082
          data: {
            html: this.html,
            file_name: ls.get('idPessoa'),
            option: options
          }
        }).then(function (response) {
          console.log('sucesso ')
        })
        // Imprimir PDF

        this.isLoading = false
        this.frame()
      } catch (error) {
        this.isLoading = false
      }
    },
    frame () {
      this.isLoading = false
      let link = ls.get('urlReport') + 'readfile/' + ls.get('idPessoa') + '.pdf'
      let frame = `<html> +
      <style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style> 
      <body>
      <iframe target="_blank" type="application/pdf" src="` + link + `"></iframe> 
      </body></html>`
      let a = window.open('about:blank', '_blank', '', true)
      a.document.write(frame)
      a.document.close()
    },

    comporHtmlPauta8 (dados, notas) {
      let pautaTrimestralConfiguracoes = this.configuracoesReport.filter(c => c.obs === 'pauta')
      let options = { 'format': 'A3',
        'orientation': 'landscape',
        'border': {
          'bottom': '10mm'

        },
        'header': {
          'height': '14mm' },
        'footer': {
          'height': '8mm'
        } }
      let htmlDasNotas = ``
      let i = 0
      notas.forEach(element => {
        i++
        htmlDasNotas += `
        <tr class="bodyText ` + this.zebraPauta(i) + `">
                    <td align="center" height="20" >
                        ` + i + `
                    </td>
                    <td style="text-align:justify;">
                         ` + element.nome + `
                    </td>
                     <td>
                       ` + this.isNull(element.t0_md) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t0_nota1) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t0_nota2) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t0_notaMac) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t1_md) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t1_nota1) + `
                    </td>

                      <td>
                         ` + this.isNull(element.t1_nota2) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t1_notaMac) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t2_md) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t2_nota1) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t2_nota2) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t2_notaMac) + `
                    </td>

                      <td>
                         ` + this.isNull(element.t3_md) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t3_nota1) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t3_nota2) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t3_notaMac) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t4_md) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t4_nota1) + `
                    </td>

                      <td>
                         ` + this.isNull(element.t4_nota2) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t4_notaMac) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t5_md) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t5_nota1) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t5_nota2) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t5_notaMac) + `
                    </td>
                     <td>
                         ` + this.isNull(element.t6_md) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t6_nota1) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t6_nota2) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t6_notaMac) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t7_md) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t7_nota1) + `
                    </td>

                     <td>
                         ` + this.isNull(element.t7_nota2) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t7_notaMac) + `
                    </td>
                    
                </tr>`
      })
      this.html = `<html>
    <head>
        <meta content="text/html; charset=utf-8" http-equiv="Content-Type">
        <style>
        table tr.bodyText td {
    text-align: center;
    font-size:12px;
}
 .zebr{
        background-color: #DCDCDC;
    }
    td.ex2 { width:10%  }
     table.ex1 { margin: 0px 10px 10px 0px; }
     body { margin: 0px 20px 0px 20px; }
.NaoTransita{
        color: red
    }
.Transita{
        color: blue
    }
     .zebr{
        background-color: #DCDCDC;
    }
    #t1 {
  -moz-tab-size: 50;
  -o-tab-size: 50;
  tab-size: 50;
}
table tr.footer td {
    border: 0;
    text-align: center;
    font-size:14px;
}
table tr.heading td {
    text-align: center;
    font-size:14px;
    height: 10px;
    width: 1%;
}
table tr.pre td {
    text-align: center;
    font-size:12px;
}
table tr.cabecalho td {
    text-align: center;
    font-size:16px;
}
table tr.cabecalho2 td {
    text-align: justify;
    font-size:14px;
}
table tr.tablehead td {
    text-align: center;
    font-size:14px;
}
  .borda-limit{
    border-right-color:black;
    border-right-width: 1px;
  }
  body { font-family: Arial, Helvetica, sans-serif; }
  div { font-family: Arial, Helvetica, sans-serif; }
  table { font-family: Arial, Helvetica, sans-serif; }
        </style>
    </head>
    <body>
     <table width="100%" BORDER=0 cellspacing="0" >
               <tr class="pre"><td width="80%"> </td> <td>Visto</td></tr>   
               <tr class="pre"><td width="80%"> </td> <td>_________________________________</td></tr>
               <tr class="pre"><td width="80%"> </td> <td>O(A) Director(a) Geral</td></tr>
          </table>

          <table width="100%" border="0" cellpadding="0" cellspacing="0">   
               <tr class="cabecalho"><td colspan="4"><img src="` + this.logotipo + `" alt="Snow" style="width:25%; max-width:50px;" /></td></tr>
               <tr class="cabecalho"><td> REPÚBLICA DE ANGOLA</td></tr>
               
               <tr class="cabecalho"><td> GOVERNO DA PROVÍNCIA DE LUANDA</td></tr>
               <tr class="cabecalho"><td>` + this.descricaoEscola() + `</td></tr>
               <tr class="cabecalho"><td>PAUTA DO ` + this.trimestre.trimestre + `</td></tr>
          </table><br>
        <div align="center">
        <table border="0" cellpadding="0" cellspacing="0">
         <tr class="tablehead">
                    <td align="left" rowspan="1" >
                  CURSO MÉDIO: &nbsp;<u>` + dados[0].curso + `</u> &nbsp; &nbsp; &nbsp;
                    </td>
                     <td align="center"  colspan="2"  >
                      Classe: &nbsp; <u> ` + this.getClasseDescricao(this.idclasse) + ` </u> &nbsp; &nbsp; &nbsp;
                    </td>
                    <td align="center"  colspan="2"  >
                      TURMA/SALA: &nbsp; <u>` + dados[0].descricao + `</u> &nbsp; &nbsp; &nbsp;
                    </td>
                    <td  >
                      PERÍODO:  &nbsp;  <u>` + dados[0].periodo + `</u> &nbsp; &nbsp; &nbsp;
                    </td>
                    <td  >
                     ANO LECTIVO: &nbsp; <u>` + this.$store.state.novadescricaoSelecionado + `</u>
                    </td>
                </tr>
          </table>
          </div>


          <div>

            <table class="ex1" BORDER=1 cellspacing="0">
               <thead>
               <tr class="tablehead">
                <td rowspan="2" width="1%">Nº</td>
               <td rowspan="2" class="ex2" >Nome </td> 
               <td align="center" colspan="4" width="60" bgcolor="#DCDCDC"  >` + dados[0].disciplina + `</td>
               <td align="center" colspan="4"  width="60" bgcolor="#DCDCDC" >` + dados[1].disciplina + `</td>
                <td align="center" colspan="4"  width="60" bgcolor="#DCDCDC" >` + dados[2].disciplina + `</td>
               <td align="center" colspan="4"  width="60" bgcolor="#DCDCDC" >` + dados[3].disciplina + `</td>
               <td align="center" colspan="4" width="60" bgcolor="#DCDCDC" >` + dados[4].disciplina + `</td>
               <td align="center" colspan="4"  width="60" bgcolor="#DCDCDC" >` + dados[5].disciplina + `</td>
                <td align="center" colspan="4"  width="60" bgcolor="#DCDCDC" >` + dados[6].disciplina + `</td>
               <td align="center" colspan="4"  width="60" bgcolor="#DCDCDC" >` + dados[7].disciplina + `</td>
               
  </tr>
      <tr   class="heading">
                 <td align="center" height="40"  width="30">
                       MD
                    </td>
                    <td align="center" height="40"  width="30">
                      P1
                    </td>
                    <td align="center" height="40"  width="30">
                       P2
                    </td>
                   <td align="center" height="40"  width="30">
                       MAC
                    </td>
                     <td align="center" height="40"  width="30">
                       MD
                    </td>
                    <td align="center" height="40"  width="30">
                       P1
                    </td>
                    <td align="center" height="40"  width="30">
                      P2
                    </td>
                   <td align="center" height="40"  width="30">
                       MAC
                    </td>
                    <td align="center" height="40"  width="30">
                       MD
                    </td>
                     <td align="center" height="40"  width="30">
                       P1
                    </td>
                   <td align="center" height="40"  width="30">
                       P2
                    </td>
                    <td align="center" height="40"  width="30">
                      Mac
                    </td>
                    <td align="center" height="40"  width="30">
                       MD
                    </td>
                    <td align="center" height="40"  width="30">
                       P1
                    </td>
                     <td align="center" height="40"  width="30">
                       P2
                    </td>
                   <td align="center" height="40"  width="30">
                       MAC
                    </td>
                   <td align="center" height="40"  width="30">
                       MD
                    </td>
                    <td align="center" height="40"  width="30">
                       P1
                    </td>
                     <td align="center" height="40"  width="30">
                       P2
                    </td>
                   <td align="center" height="40"  width="30">
                       MAC
                    </td>
                    <td align="center" height="40"  width="30">
                      Md
                    </td>
                    <td align="center" height="40"  width="30">
                       P1
                    </td>
                    <td align="center" height="40"  width="30">
                       P2
                    </td>
                    <td align="center" height="40"  width="30">
                       MAC
                    </td>
                     <td align="center" height="40"  width="30">
                      Md
                    </td>
                    <td align="center" height="40"  width="30">
                       P1
                    </td>
                    <td align="center" height="40"  width="30">
                       P2
                    </td>
                    <td align="center" height="40"  width="30">
                       MAC
                    </td>
                      <td align="center" height="40"  width="30">
                      Md
                    </td>
                    <td align="center" height="40"  width="30">
                       P1
                    </td>
                    <td align="center" height="40"  width="30">
                       P2
                    </td>
                    <td align="center" height="40"  width="30">
                       MAC
                    </td>
                             
                </tr>
               </thead>
               ` + htmlDasNotas + `
                </table>
          </div>
          <br>
          <table width="100%" cellspacing="0" >
<tr class="footer">
    <td>` + pautaTrimestralConfiguracoes[1].valor + `</td>
    <td> ` + help.presente_data() + `</td>
    <td> ` + pautaTrimestralConfiguracoes[2].valor + ` </td>
   <tr class="footer">
       <td>_____________________________________________________</td>
       <td></td>
       <td>_____________________________________________________</td>

       </tr>
         </table>

</footer>
    </body>
</html>`
      this.pautasgerarpdf(options)
    },
    comporHtmlPauta9 (dados, notas) {
      let pautaTrimestralConfiguracoes = this.configuracoesReport.filter(c => c.obs === 'pauta')
      let options = { 'format': 'A3',
        'orientation': 'landscape',
        'border': {
          'bottom': '10mm'

        },
        'header': {
          'height': '14mm' },
        'footer': {
          'height': '7mm'
        } }
      let htmlDasNotas = ``
      let i = 0
      notas.forEach(element => {
        i++
        htmlDasNotas += `
        <tr class="bodyText ` + this.zebraPauta(i) + `">
                    <td align="center" height="20" >
                        ` + i + `
                    </td>
                    <td style="text-align:justify;">
                         ` + element.nome + `
                    </td>
                     <td>
                       ` + this.isNull(element.t0_md) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t0_nota1) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t0_nota2) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t0_notaMac) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t1_md) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t1_nota1) + `
                    </td>

                      <td>
                         ` + this.isNull(element.t1_nota2) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t1_notaMac) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t2_md) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t2_nota1) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t2_nota2) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t2_notaMac) + `
                    </td>

                      <td>
                         ` + this.isNull(element.t3_md) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t3_nota1) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t3_nota2) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t3_notaMac) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t4_md) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t4_nota1) + `
                    </td>

                      <td>
                         ` + this.isNull(element.t4_nota2) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t4_notaMac) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t5_md) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t5_nota1) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t5_nota2) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t5_notaMac) + `
                    </td>
                     <td>
                         ` + this.isNull(element.t6_md) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t6_nota1) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t6_nota2) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t6_notaMac) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t7_md) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t7_nota1) + `
                    </td>

                     <td>
                         ` + this.isNull(element.t7_nota2) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t7_notaMac) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t8_md) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t8_nota1) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t8_nota2) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t8_notaMac) + `
                    </td>
                     
                </tr>`
      })
      this.html = `<html>
    <head>
        <meta content="text/html; charset=utf-8" http-equiv="Content-Type">
        <style>
        table tr.bodyText td {
    text-align: center;
    font-size:12px;
}
 .zebr{
        background-color: #DCDCDC;
    }
    td.ex2 { width:10%  }
     table.ex1 { margin: 0px 10px 10px 0px; }
     body { margin: 0px 20px 0px 20px; }
.NaoTransita{
        color: red
    }
.Transita{
        color: blue
    }
     .zebr{
        background-color: #DCDCDC;
    }
    #t1 {
  -moz-tab-size: 50;
  -o-tab-size: 50;
  tab-size: 50;
}
table tr.footer td {
    border: 0;
    text-align: center;
    font-size:14px;
}
table tr.heading td {
    text-align: center;
    font-size:14px;
    height: 10px;
    width: 1%;
}
table tr.pre td {
    text-align: center;
    font-size:12px;
}
table tr.cabecalho td {
    text-align: center;
    font-size:16px;
}
table tr.cabecalho2 td {
    text-align: justify;
    font-size:14px;
}
table tr.tablehead td {
    text-align: center;
    font-size:14px;
}
  .borda-limit{
    border-right-color:black;
    border-right-width: 1px;
  }
  body { font-family: Arial, Helvetica, sans-serif; }
  div { font-family: Arial, Helvetica, sans-serif; }
  table { font-family: Arial, Helvetica, sans-serif; }
        </style>
    </head>
    <body>
     <table width="100%" BORDER=0 cellspacing="0" >
               <tr class="pre"><td width="80%"> </td> <td>Visto</td></tr>   
               <tr class="pre"><td width="80%"> </td> <td>_________________________________</td></tr>
               <tr class="pre"><td width="80%"> </td> <td>O(A) Director(a) Geral</td></tr>
          </table>

          <table width="100%" border="0" cellpadding="0" cellspacing="0">   
               <tr class="cabecalho"><td colspan="4"><img src="` + this.logotipo + `" alt="Snow" style="width:25%; max-width:50px;" /></td></tr>
               <tr class="cabecalho"><td> REPÚBLICA DE ANGOLA</td></tr>
               
               <tr class="cabecalho"><td> GOVERNO DA PROVÍNCIA DE LUANDA</td></tr>
               <tr class="cabecalho"><td>` + this.descricaoEscola() + `</td></tr>
               <tr class="cabecalho"><td>PAUTA DO ` + this.trimestre.trimestre + `</td></tr>
          </table><br>
       
        <table border="0" cellpadding="0" cellspacing="0">
         <tr class="tablehead">
                    <td align="left" rowspan="1" >
                  CURSO MÉDIO: &nbsp;<u>` + dados[0].curso + `</u> &nbsp; &nbsp; &nbsp;
                    </td>
                     <td align="center"  colspan="2"  >
                      Classe: &nbsp; <u> ` + this.getClasseDescricao(this.idclasse) + ` </u> &nbsp; &nbsp; &nbsp;
                    </td>
                    <td align="center"  colspan="2"  >
                      TURMA/SALA: &nbsp; <u>` + dados[0].descricao + `</u> &nbsp; &nbsp; &nbsp;
                    </td>
                    <td  >
                      PERÍODO:  &nbsp;  <u>` + dados[0].periodo + `</u> &nbsp; &nbsp; &nbsp;
                    </td>
                    <td  >
                     ANO LECTIVO: &nbsp; <u>` + this.$store.state.novadescricaoSelecionado + `</u>
                    </td>
                </tr>
          </table>

          <div>

            <table class="ex1" BORDER=1 cellspacing="0">
               <thead>
               <tr class="tablehead">
                <td rowspan="2" width="1%">Nº</td>
               <td rowspan="2" class="ex2" >Nome </td> 
               <td align="center" colspan="4" width="60" bgcolor="#DCDCDC" >` + dados[0].disciplina + `</td>
               <td align="center" colspan="4"  width="60" bgcolor="#DCDCDC" >` + dados[1].disciplina + `</td>
                <td align="center" colspan="4"  width="60" bgcolor="#DCDCDC" >` + dados[2].disciplina + `</td>
               <td align="center" colspan="4"  width="60" bgcolor="#DCDCDC" >` + dados[3].disciplina + `</td>
               <td align="center" colspan="4" width="60" bgcolor="#DCDCDC" >` + dados[4].disciplina + `</td>
               <td align="center" colspan="4"  width="60" bgcolor="#DCDCDC" >` + dados[5].disciplina + `</td>
                <td align="center" colspan="4"  width="60" bgcolor="#DCDCDC" >` + dados[6].disciplina + `</td>
               <td align="center" colspan="4"  width="60" bgcolor="#DCDCDC" >` + dados[7].disciplina + `</td>
                <td align="center" colspan="4"  width="60" bgcolor="#DCDCDC" >` + dados[8].disciplina + `</td>
               
  </tr>
      <tr   class="heading">
                  <td align="center" height="40"  width="30">
                       MD
                    </td>
                    <td align="center" height="40"  width="30">
                      P1
                    </td>
                    <td align="center" height="40"  width="30">
                       P2
                    </td>
                   <td align="center" height="40"  width="30">
                       MAC
                    </td>
                     <td align="center" height="40"  width="30">
                       MD
                    </td>
                    <td align="center" height="40"  width="30">
                       P1
                    </td>
                    <td align="center" height="40"  width="30">
                      P2
                    </td>
                   <td align="center" height="40"  width="30">
                       MAC
                    </td>
                    <td align="center" height="40"  width="30">
                       MD
                    </td>
                     <td align="center" height="40"  width="30">
                       P1
                    </td>
                   <td align="center" height="40"  width="30">
                       P2
                    </td>
                    <td align="center" height="40"  width="30">
                      Mac
                    </td>
                    <td align="center" height="40"  width="30">
                       MD
                    </td>
                    <td align="center" height="40"  width="30">
                       P1
                    </td>
                     <td align="center" height="40"  width="30">
                       P2
                    </td>
                   <td align="center" height="40"  width="30">
                       MAC
                    </td>
                   <td align="center" height="40"  width="30">
                       MD
                    </td>
                    <td align="center" height="40"  width="30">
                       P1
                    </td>
                     <td align="center" height="40"  width="30">
                       P2
                    </td>
                   <td align="center" height="40"  width="30">
                       MAC
                    </td>
                    <td align="center" height="40"  width="30">
                      Md
                    </td>
                    <td align="center" height="40"  width="30">
                       P1
                    </td>
                    <td align="center" height="40"  width="30">
                       P2
                    </td>
                    <td align="center" height="40"  width="30">
                       MAC
                    </td>
                     <td align="center" height="40"  width="30">
                      Md
                    </td>
                    <td align="center" height="40"  width="30">
                       P1
                    </td>
                    <td align="center" height="40"  width="30">
                       P2
                    </td>
                    <td align="center" height="40"  width="30">
                       MAC
                    </td>
                      <td align="center" height="40"  width="30">
                      Md
                    </td>
                    <td align="center" height="40"  width="30">
                       P1
                    </td>
                    <td align="center" height="40"  width="30">
                       P2
                    </td>
                    <td align="center" height="40"  width="30">
                       MAC
                    </td>
                     <td align="center" height="40"  width="30">
                      Md
                    </td>
                    <td align="center" height="40"  width="30">
                       P1
                    </td>
                    <td align="center" height="40"  width="30">
                       P2
                    </td>
                    <td align="center" height="40"  width="30">
                       MAC
                    </td>
                                
                </tr>
               </thead>
               ` + htmlDasNotas + `
                </table>
          </div>
          <br>
          <table width="100%" cellspacing="0" >
<tr class="footer">
    <td>` + pautaTrimestralConfiguracoes[1].valor + `</td>
    <td> ` + help.presente_data() + `</td>
    <td> ` + pautaTrimestralConfiguracoes[2].valor + ` </td>
   <tr class="footer">
       <td>_____________________________________________________</td>
       <td></td>
       <td>_____________________________________________________</td>

       </tr>
         </table>
    </body>
</html>`
      this.pautasgerarpdf(options)
    },
    comporHtmlPauta10 (dados, notas) {
      let pautaTrimestralConfiguracoes = this.configuracoesReport.filter(c => c.obs === 'pauta')
      let options = { 'format': 'A3',
        'orientation': 'landscape',
        'border': {
          'bottom': '10mm'
        },
        'header': {
          'height': '14mm' },
        'footer': {
          'height': '7mm'
        } }
      let htmlDasNotas = ``
      let i = 0
      notas.forEach(element => {
        i++
        htmlDasNotas += `
        <tr class="bodyText ` + this.zebraPauta(i) + `">
                    <td align="center" height="20" >
                        ` + i + `
                    </td>
                    <td style="text-align:justify;">
                         ` + element.nome + `
                    </td>
                    <td>
                       ` + this.isNull(element.t0_md) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t0_nota1) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t0_nota2) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t0_notaMac) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t1_md) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t1_nota1) + `
                    </td>

                      <td>
                         ` + this.isNull(element.t1_nota2) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t1_notaMac) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t2_md) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t2_nota1) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t2_nota2) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t2_notaMac) + `
                    </td>

                      <td>
                         ` + this.isNull(element.t3_md) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t3_nota1) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t3_nota2) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t3_notaMac) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t4_md) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t4_nota1) + `
                    </td>

                      <td>
                         ` + this.isNull(element.t4_nota2) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t4_notaMac) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t5_md) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t5_nota1) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t5_nota2) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t5_notaMac) + `
                    </td>
                     <td>
                         ` + this.isNull(element.t6_md) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t6_nota1) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t6_nota2) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t6_notaMac) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t7_md) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t7_nota1) + `
                    </td>

                     <td>
                         ` + this.isNull(element.t7_nota2) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t7_notaMac) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t8_md) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t8_nota1) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t8_nota2) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t8_notaMac) + `
                    </td>

                     <td>
                         ` + this.isNull(element.t9_md) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t9_nota1) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t9_nota2) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t9_notaMac) + `
                    </td>
                    
                </tr>`
      })
      this.html = `<html>
    <head>
        <meta content="text/html; charset=utf-8" http-equiv="Content-Type">
        <style>
        table tr.bodyText td {
    text-align: center;
    font-size:12px;
}
 .zebr{
        background-color: #DCDCDC;
    }
    td.ex2 { width:10%  }
     table.ex1 { margin: 0px 10px 10px 0px; }
     body { margin: 0px 20px 0px 20px; }
.NaoTransita{
        color: red
    }
.Transita{
        color: blue
    }
     .zebr{
        background-color: #DCDCDC;
    }
    #t1 {
  -moz-tab-size: 50;
  -o-tab-size: 50;
  tab-size: 50;
}
table tr.footer td {
    border: 0;
    text-align: center;
    font-size:14px;
}
table tr.heading td {
    text-align: center;
    font-size:14px;
    height: 10px;
    width: 1%;
}
table tr.pre td {
    text-align: center;
    font-size:12px;
}
table tr.cabecalho td {
    text-align: center;
    font-size:16px;
}
table tr.cabecalho2 td {
    text-align: justify;
    font-size:14px;
}
table tr.tablehead td {
    text-align: center;
    font-size:14px;
}
  .borda-limit{
    border-right-color:black;
    border-right-width: 1px;
  }
  body { font-family: Arial, Helvetica, sans-serif; }
  div { font-family: Arial, Helvetica, sans-serif; }
  table { font-family: Arial, Helvetica, sans-serif; }
        </style>
    </head>
    <body>
     <table width="100%" BORDER=0 cellspacing="0" >
               <tr class="pre"><td width="80%"> </td> <td>Visto</td></tr>   
               <tr class="pre"><td width="80%"> </td> <td>_________________________________</td></tr>
               <tr class="pre"><td width="80%"> </td> <td>O(A) Director(a) Geral</td></tr>
          </table>

          <table width="100%" border="0" cellpadding="0" cellspacing="0">   
               <tr class="cabecalho"><td colspan="4"><img src="` + this.logotipo + `" alt="Snow" style="width:25%; max-width:50px;" /></td></tr>
               <tr class="cabecalho"><td> REPÚBLICA DE ANGOLA</td></tr>
               
               <tr class="cabecalho"><td> GOVERNO DA PROVÍNCIA DE LUANDA</td></tr>
               <tr class="cabecalho"><td>` + this.descricaoEscola() + `</td></tr>
               <tr class="cabecalho"><td>PAUTA DO ` + this.trimestre.trimestre + `</td></tr>
          </table><br>

        <table border="0" cellpadding="0" cellspacing="0">
         <tr class="tablehead">
                    <td align="left" rowspan="1" >
                  CURSO MÉDIO: &nbsp;<u>` + dados[0].curso + `</u> &nbsp; &nbsp; &nbsp;
                    </td>
                     <td align="center"  colspan="2"  >
                      Classe: &nbsp; <u> ` + this.getClasseDescricao(this.idclasse) + ` </u> &nbsp; &nbsp; &nbsp;
                    </td>
                    <td align="center"  colspan="2"  >
                      TURMA/SALA: &nbsp; <u>` + dados[0].descricao + `</u> &nbsp; &nbsp; &nbsp;
                    </td>
                    <td  >
                      PERÍODO:  &nbsp;  <u>` + dados[0].periodo + `</u> &nbsp; &nbsp; &nbsp;
                    </td>
                    <td  >
                     ANO LECTIVO: &nbsp; <u>` + this.$store.state.novadescricaoSelecionado + `</u>
                    </td>
                </tr>
          </table>

          <div>

            <table class="ex1" BORDER=1 cellspacing="0" class="report-container">
               <thead >
               <tr class="tablehead">
               <td rowspan="2" width="1%">Nº</td>
               <td rowspan="2" class="ex2" >Nome </td> 
               <td align="center" colspan="4" width="60" bgcolor="#DCDCDC" >` + dados[0].disciplina + `</td>
               <td align="center" colspan="4"  width="60" bgcolor="#DCDCDC">` + dados[1].disciplina + `</td>
                <td align="center" colspan="4"  width="60" bgcolor="#DCDCDC">` + dados[2].disciplina + `</td>
               <td align="center" colspan="4"  width="60" bgcolor="#DCDCDC">` + dados[3].disciplina + `</td>
               <td align="center" colspan="4" width="60" bgcolor="#DCDCDC" >` + dados[4].disciplina + `</td>
               <td align="center" colspan="4"  width="60" bgcolor="#DCDCDC">` + dados[5].disciplina + `</td>
                <td align="center" colspan="4"  width="60" bgcolor="#DCDCDC">` + dados[6].disciplina + `</td>
               <td align="center" colspan="4"  width="60" bgcolor="#DCDCDC">` + dados[7].disciplina + `</td>
                <td align="center" colspan="4"  width="60" bgcolor="#DCDCDC">` + dados[8].disciplina + `</td>
               <td align="center" colspan="4"  width="60" bgcolor="#DCDCDC">` + dados[9].disciplina + `</td>
               
  </tr>
      <tr   class="heading">
               <td align="center" height="40"  width="30">
                       MD
                    </td>
                    <td align="center" height="40"  width="30">
                      P1
                    </td>
                    <td align="center" height="40"  width="30">
                       P2
                    </td>
                   <td align="center" height="40"  width="30">
                       MAC
                    </td>
                     <td align="center" height="40"  width="30">
                       MD
                    </td>
                    <td align="center" height="40"  width="30">
                       P1
                    </td>
                    <td align="center" height="40"  width="30">
                      P2
                    </td>
                   <td align="center" height="40"  width="30">
                       MAC
                    </td>
                    <td align="center" height="40"  width="30">
                       MD
                    </td>
                     <td align="center" height="40"  width="30">
                       P1
                    </td>
                   <td align="center" height="40"  width="30">
                       P2
                    </td>
                    <td align="center" height="40"  width="30">
                      Mac
                    </td>
                    <td align="center" height="40"  width="30">
                       MD
                    </td>
                    <td align="center" height="40"  width="30">
                       P1
                    </td>
                     <td align="center" height="40"  width="30">
                       P2
                    </td>
                   <td align="center" height="40"  width="30">
                       MAC
                    </td>
                   <td align="center" height="40"  width="30">
                       MD
                    </td>
                    <td align="center" height="40"  width="30">
                       P1
                    </td>
                     <td align="center" height="40"  width="30">
                       P2
                    </td>
                   <td align="center" height="40"  width="30">
                       MAC
                    </td>
                    <td align="center" height="40"  width="30">
                      Md
                    </td>
                    <td align="center" height="40"  width="30">
                       P1
                    </td>
                    <td align="center" height="40"  width="30">
                       P2
                    </td>
                    <td align="center" height="40"  width="30">
                       MAC
                    </td>
                     <td align="center" height="40"  width="30">
                      Md
                    </td>
                    <td align="center" height="40"  width="30">
                       P1
                    </td>
                    <td align="center" height="40"  width="30">
                       P2
                    </td>
                    <td align="center" height="40"  width="30">
                       MAC
                    </td>
                      <td align="center" height="40"  width="30">
                      Md
                    </td>
                    <td align="center" height="40"  width="30">
                       P1
                    </td>
                    <td align="center" height="40"  width="30">
                       P2
                    </td>
                    <td align="center" height="40"  width="30">
                       MAC
                    </td>
                     <td align="center" height="40"  width="30">
                      Md
                    </td>
                    <td align="center" height="40"  width="30">
                       P1
                    </td>
                    <td align="center" height="40"  width="30">
                       P2
                    </td>
                    <td align="center" height="40"  width="30">
                       MAC
                    </td>
                     <td align="center" height="40"  width="30">
                      Md
                    </td>
                    <td align="center" height="40"  width="30">
                       P1
                    </td>
                    <td align="center" height="40"  width="30">
                       P2
                    </td>
                    <td align="center" height="40"  width="30">
                       MAC
                    </td>
                   
                               
                </tr>
               </thead>
               ` + htmlDasNotas + `
                </table>
          </div>
          <br>
          <table width="100%" cellspacing="0" >
<tr class="footer">
    <td>` + pautaTrimestralConfiguracoes[1].valor + `</td>
    <td> ` + help.presente_data() + `</td>
    <td> ` + pautaTrimestralConfiguracoes[2].valor + ` </td>
   <tr class="footer">
       <td>_____________________________________________________</td>
       <td></td>
       <td>_____________________________________________________</td>

       </tr>
         </table>
    </body>
</html>`
      this.pautasgerarpdf(options)
    },
    comporHtmlPauta11 (dados, notas) {
      let pautaTrimestralConfiguracoes = this.configuracoesReport.filter(c => c.obs === 'pauta')
      let options = { 'format': 'A3',
        'orientation': 'landscape',
        'border': {
          'bottom': '12mm'

        },
        'header': {
          'height': '12mm' },
        'footer': {
          'height': '5mm'
        } }
      let htmlDasNotas = ``
      let i = 0
      notas.forEach(element => {
        i++
        htmlDasNotas += `
        <tr class="bodyText ` + this.zebraPauta(i) + `">
                    <td align="center" height="20" >
                        ` + i + `
                    </td>
                    <td style="text-align:justify;">
                         ` + element.nome + `
                    </td>
                     <td >
                       ` + this.isNull(element.t0_md) + `
                    </td>
                    <td >
                         ` + this.isNull(element.t0_nota1) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t0_nota2) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t0_notaMac) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t1_md) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t1_nota1) + `
                    </td>

                      <td>
                         ` + this.isNull(element.t1_nota2) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t1_notaMac) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t2_md) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t2_nota1) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t2_nota2) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t2_notaMac) + `
                    </td>

                      <td>
                         ` + this.isNull(element.t3_md) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t3_nota1) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t3_nota2) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t3_notaMac) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t4_md) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t4_nota1) + `
                    </td>

                      <td>
                         ` + this.isNull(element.t4_nota2) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t4_notaMac) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t5_md) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t5_nota1) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t5_nota2) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t5_notaMac) + `
                    </td>
                     <td>
                         ` + this.isNull(element.t6_md) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t6_nota1) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t6_nota2) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t6_notaMac) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t7_md) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t7_nota1) + `
                    </td>

                     <td>
                         ` + this.isNull(element.t7_nota2) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t7_notaMac) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t8_md) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t8_nota1) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t8_nota2) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t8_notaMac) + `
                    </td>

                     <td>
                         ` + this.isNull(element.t9_md) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t9_nota1) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t9_nota2) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t9_notaMac) + `
                    </td>
                      <td>
                         ` + this.isNull(element.t10_md) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t10_nota1) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t10_nota2) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t10_notaMac) + `
                    </td>

                    
                </tr>`
      })
      this.html = `<html>
    <head>
        <meta content="text/html; charset=utf-8" http-equiv="Content-Type">
        <style>
        table tr.bodyText td {
    text-align: center;
    font-size:12px;
}
 .zebr{
        background-color: #DCDCDC;
    }
    td.ex2 { width:10%  }
     table.ex1 { margin: 0px 10px 10px 0px; }
     body { margin: 0px 20px 0px 20px; }
.NaoTransita{
        color: red
    }
.Transita{
        color: blue
    }
     .zebr{
        background-color: #DCDCDC;
    }
    #t1 {
  -moz-tab-size: 50;
  -o-tab-size: 50;
  tab-size: 50;
}
table tr.footer td {
    border: 0;
    text-align: center;
    font-size:14px;
}
table tr.heading td {
    text-align: center;
    font-size:14px;
    height: 10px;
    width: 1%;
}
table tr.pre td {
    text-align: center;
    font-size:12px;
}
table tr.cabecalho td {
    text-align: center;
    font-size:16px;
}
table tr.cabecalho2 td {
    text-align: justify;
    font-size:14px;
}
table tr.tablehead td {
    text-align: center;
    font-size:14px;
}
  .borda-limit{
    border-right-color:black;
    border-right-width: 1px;
  }
  body { font-family: Arial, Helvetica, sans-serif; }
  div { font-family: Arial, Helvetica, sans-serif; }
  table { font-family: Arial, Helvetica, sans-serif; }
        </style>
    </head>
    <body>
     <table width="100%" BORDER=0 cellspacing="0" >
               <tr class="pre"><td width="80%"> </td> <td>Visto</td></tr>   
               <tr class="pre"><td width="80%"> </td> <td>_________________________________</td></tr>
               <tr class="pre"><td width="80%"> </td> <td>O(A) Director(a) Geral</td></tr>
          </table>

          <table width="100%" border="0" cellpadding="0" cellspacing="0">   
               <tr class="cabecalho"><td colspan="4"><img src="` + this.logotipo + `" alt="Snow" style="width:25%; max-width:50px;" /></td></tr>
               <tr class="cabecalho"><td> REPÚBLICA DE ANGOLA</td></tr>
               
               <tr class="cabecalho"><td> GOVERNO DA PROVÍNCIA DE LUANDA</td></tr>
               <tr class="cabecalho"><td>` + this.descricaoEscola() + `</td></tr>
               <tr class="cabecalho"><td>PAUTA DO ` + this.trimestre.trimestre + `</td></tr>
          </table><br>

        <table border="0" cellpadding="0" cellspacing="0">
         <tr class="tablehead">
                    <td align="left" rowspan="1" >
                  CURSO MÉDIO: &nbsp;<u>` + dados[0].curso + `</u> &nbsp; &nbsp; &nbsp;
                    </td>
                     <td align="center"  colspan="2"  >
                      Classe: &nbsp; <u> ` + this.getClasseDescricao(this.idclasse) + ` </u> &nbsp; &nbsp; &nbsp;
                    </td>
                    <td align="center"  colspan="2"  >
                      TURMA/SALA: &nbsp; <u>` + dados[0].descricao + `</u> &nbsp; &nbsp; &nbsp;
                    </td>
                    <td  >
                      PERÍODO:  &nbsp;  <u>` + dados[0].periodo + `</u> &nbsp; &nbsp; &nbsp;
                    </td>
                    <td  >
                     ANO LECTIVO: &nbsp; <u>` + this.$store.state.novadescricaoSelecionado + `</u>
                    </td>
                </tr>
          </table>


          <div>

            <table class="ex1" BORDER=1 cellspacing="0" class="report-container">
               <thead>
               <tr class="tablehead">
               <td rowspan="2" width="1%">Nº</td>
               <td rowspan="2" class="ex2" >Nome </td> 
               <td align="center" colspan="4" width="60" bgcolor="#DCDCDC" >` + dados[0].disciplina + `</td>
               <td align="center" colspan="4"  width="60" bgcolor="#DCDCDC" >` + dados[1].disciplina + `</td>
                <td align="center" colspan="4"  width="60" bgcolor="#DCDCDC" >` + dados[2].disciplina + `</td>
               <td align="center" colspan="4"  width="60" bgcolor="#DCDCDC" >` + dados[3].disciplina + `</td>
               <td align="center" colspan="4" width="60" bgcolor="#DCDCDC" >` + dados[4].disciplina + `</td>
               <td align="center" colspan="4"  width="60" bgcolor="#DCDCDC" >` + dados[5].disciplina + `</td>
                <td align="center" colspan="4"  width="60" bgcolor="#DCDCDC" >` + dados[6].disciplina + `</td>
               <td align="center" colspan="4"  width="60" bgcolor="#DCDCDC" >` + dados[7].disciplina + `</td>
                <td align="center" colspan="4"  width="60" bgcolor="#DCDCDC" >` + dados[8].disciplina + `</td>
               <td align="center" colspan="4"  width="60" bgcolor="#DCDCDC" >` + dados[9].disciplina + `</td>
               <td align="center" colspan="4" width="60" bgcolor="#DCDCDC" >` + dados[10].disciplina + `</td>
               
  </tr>
      <tr   class="heading">
                <td align="center" height="40"  width="30">
                       MD
                    </td>
                    <td align="center" height="40"  width="30">
                      P1
                    </td>
                    <td align="center" height="40"  width="30">
                       P2
                    </td>
                   <td align="center" height="40"  width="30">
                       MAC
                    </td>
                    <td align="center" height="40"  width="30">
                       MD
                    </td>
                    <td align="center" height="40"  width="30">
                      P1
                    </td>
                    <td align="center" height="40"  width="30">
                       P2
                    </td>
                   <td align="center" height="40"  width="30">
                       MAC
                    </td>
                    <td align="center" height="40"  width="30">
                       MD
                    </td>
                    <td align="center" height="40"  width="30">
                      P1
                    </td>
                    <td align="center" height="40"  width="30">
                       P2
                    </td>
                   <td align="center" height="40"  width="30">
                       MAC
                    </td>
                    <td align="center" height="40"  width="30">
                       MD
                    </td>
                    <td align="center" height="40"  width="30">
                      P1
                    </td>
                    <td align="center" height="40"  width="30">
                       P2
                    </td>
                   <td align="center" height="40"  width="30">
                       MAC
                    </td>
                     <td align="center" height="40"  width="30">
                       MD
                    </td>
                    <td align="center" height="40"  width="30">
                      P1
                    </td>
                    <td align="center" height="40"  width="30">
                       P2
                    </td>
                   <td align="center" height="40"  width="30">
                       MAC
                    </td>
                    <td align="center" height="40"  width="30">
                       MD
                    </td>
                    <td align="center" height="40"  width="30">
                      P1
                    </td>
                    <td align="center" height="40"  width="30">
                       P2
                    </td>
                   <td align="center" height="40"  width="30">
                       MAC
                    </td>
                    <td align="center" height="40"  width="30">
                       MD
                    </td>
                    <td align="center" height="40"  width="30">
                      P1
                    </td>
                    <td align="center" height="40"  width="30">
                       P2
                    </td>
                   <td align="center" height="40"  width="30">
                       MAC
                    </td>
                    <td align="center" height="40"  width="30">
                       MD
                    </td>
                    <td align="center" height="40"  width="30">
                      P1
                    </td>
                    <td align="center" height="40"  width="30">
                       P2
                    </td>
                   <td align="center" height="40"  width="30">
                       MAC
                    </td>
                    <td align="center" height="40"  width="30">
                       MD
                    </td>
                    <td align="center" height="40"  width="30">
                      P1
                    </td>
                    <td align="center" height="40"  width="30">
                       P2
                    </td>
                   <td align="center" height="40"  width="30">
                       MAC
                    </td>
                    <td align="center" height="40"  width="30">
                       MD
                    </td>
                    <td align="center" height="40"  width="30">
                      P1
                    </td>
                    <td align="center" height="40"  width="30">
                       P2
                    </td>
                   <td align="center" height="40"  width="30">
                       MAC
                    </td>
                    <td align="center" height="40"  width="30">
                       MD
                    </td>
                    <td align="center" height="40"  width="30">
                      P1
                    </td>
                    <td align="center" height="40"  width="30">
                       P2
                    </td>
                   <td align="center" height="40"  width="30">
                       MAC
                    </td>                
                      
                         
                </tr>
               </thead>
               ` + htmlDasNotas + `
                </table>
          </div>
          <br>
          <table width="100%" cellspacing="0" >
<tr class="footer">
    <td>` + pautaTrimestralConfiguracoes[1].valor + `</td>
    <td> ` + help.presente_data() + `</td>
    <td> ` + pautaTrimestralConfiguracoes[2].valor + ` </td>
   <tr class="footer">
       <td>_____________________________________________________</td>
       <td></td>
       <td>_____________________________________________________</td>

       </tr>
         </table>
    </body>
</html>`
      this.pautasgerarpdf(options)
    },
    comporHtmlPauta12 (dados, notas) {
      let pautaTrimestralConfiguracoes = this.configuracoesReport.filter(c => c.obs === 'pauta')
      let options = { 'format': 'A3',
        'orientation': 'landscape',
        'border': {
          'bottom': '10mm'

        },
        'header': {
          'height': '14mm' },
        'footer': {
          'height': '5mm'
        } }
      let htmlDasNotas = ``
      let i = 0
      notas.forEach(element => {
        i++
        htmlDasNotas += `
        <tr class="bodyText ` + this.zebraPauta(i) + `">
                    <td align="center" height="20" >
                        ` + i + `
                    </td>
                    <td style="text-align:justify;">
                         ` + element.nome + `
                    </td>
                  <td>
                       ` + this.isNull(element.t0_md) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t0_nota1) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t0_nota2) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t0_notaMac) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t1_md) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t1_nota1) + `
                    </td>

                      <td>
                         ` + this.isNull(element.t1_nota2) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t1_notaMac) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t2_md) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t2_nota1) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t2_nota2) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t2_notaMac) + `
                    </td>

                      <td>
                         ` + this.isNull(element.t3_md) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t3_nota1) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t3_nota2) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t3_notaMac) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t4_md) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t4_nota1) + `
                    </td>

                      <td>
                         ` + this.isNull(element.t4_nota2) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t4_notaMac) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t5_md) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t5_nota1) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t5_nota2) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t5_notaMac) + `
                    </td>
                     <td>
                         ` + this.isNull(element.t6_md) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t6_nota1) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t6_nota2) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t6_notaMac) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t7_md) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t7_nota1) + `
                    </td>

                     <td>
                         ` + this.isNull(element.t7_nota2) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t7_notaMac) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t8_md) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t8_nota1) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t8_nota2) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t8_notaMac) + `
                    </td>

                     <td>
                         ` + this.isNull(element.t9_md) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t9_nota1) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t9_nota2) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t9_notaMac) + `
                    </td>
                      <td>
                         ` + this.isNull(element.t10_md) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t10_nota1) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t10_nota2) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t10_notaMac) + `
                    </td>

                      <td>
                         ` + this.isNull(element.t11_md) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t11_nota1) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t11_nota2) + `
                    </td>
                    <td>
                         ` + this.isNull(element.t11_notaMac) + `
                    </td>
                    
                </tr>`
      })
      this.html = `<html>
    <head>
        <meta content="text/html; charset=utf-8" http-equiv="Content-Type">
        <style>
        table tr.bodyText td {
    text-align: center;
    font-size:12px;
}
 .zebr{
        background-color: #DCDCDC;
    }
    td.ex2 { width:10%  }
     table.ex1 { margin: 0px 10px 10px 0px; }
     body { margin: 0px 20px 0px 20px; }
.NaoTransita{
        color: red
    }
.Transita{
        color: blue
    }
     .zebr{
        background-color: #DCDCDC;
    }
    #t1 {
  -moz-tab-size: 50;
  -o-tab-size: 50;
  tab-size: 50;
}
table tr.footer td {
    border: 0;
    text-align: center;
    font-size:14px;
}
table tr.heading td {
    text-align: center;
    font-size:14px;
    height: 10px;
    width: 1%;
}
table tr.pre td {
    text-align: center;
    font-size:12px;
}
table tr.cabecalho td {
    text-align: center;
    font-size:16px;
}
table tr.cabecalho2 td {
    text-align: justify;
    font-size:14px;
}
table tr.tablehead td {
    text-align: center;
    font-size:14px;
}
  .borda-limit{
    border-right-color:black;
    border-right-width: 1px;
  }
  body { font-family: Arial, Helvetica, sans-serif; }
  div { font-family: Arial, Helvetica, sans-serif; }
  table { font-family: Arial, Helvetica, sans-serif; }
        </style>
    </head>
    <body>
     <table width="100%" BORDER=0 cellspacing="0" >
               <tr class="pre"><td width="80%"> </td> <td>Visto</td></tr>   
               <tr class="pre"><td width="80%"> </td> <td>_________________________________</td></tr>
               <tr class="pre"><td width="80%"> </td> <td>O(A) Director(a) Geral</td></tr>
          </table>

          <table width="100%" border="0" cellpadding="0" cellspacing="0">   
               <tr class="cabecalho"><td colspan="4"><img src="` + this.logotipo + `" alt="Snow" style="width:25%; max-width:50px;" /></td></tr>
               <tr class="cabecalho"><td> REPÚBLICA DE ANGOLA</td></tr>
               
               <tr class="cabecalho"><td> GOVERNO DA PROVÍNCIA DE LUANDA</td></tr>
               <tr class="cabecalho"><td>` + this.descricaoEscola() + `</td></tr>
               <tr class="cabecalho"><td>PAUTA DO ` + this.trimestre.trimestre + `</td></tr>
          </table><br>
        
        <table border="0" cellpadding="0" cellspacing="0">
         <tr class="tablehead">
                    <td align="left" rowspan="1" >
                  CURSO MÉDIO: &nbsp;<u>` + dados[0].curso + `</u> &nbsp; &nbsp; &nbsp;
                    </td>
                     <td align="center"  colspan="2"  >
                      Classe: &nbsp; <u> ` + this.getClasseDescricao(this.idclasse) + ` </u> &nbsp; &nbsp; &nbsp;
                    </td>
                    <td align="center"  colspan="2"  >
                      TURMA/SALA: &nbsp; <u>` + dados[0].descricao + `</u> &nbsp; &nbsp; &nbsp;
                    </td>
                    <td  >
                      PERÍODO:  &nbsp;  <u>` + dados[0].periodo + `</u> &nbsp; &nbsp; &nbsp;
                    </td>
                    <td  >
                     ANO LECTIVO: &nbsp; <u>` + this.$store.state.novadescricaoSelecionado + `</u>
                    </td>
                </tr>
          </table>
          
          <div>

            <table   BORDER=1 cellspacing="0" class="ex1" class="row-item">
               <thead>
                <tr class="tablehead">
               <td rowspan="2" width="1%">Nº</td>
               <td rowspan="2" class="ex2" >Nome </td> 
               <td align="center" colspan="4"  bgcolor="#DCDCDC" >` + dados[0].disciplina + `</td>
               <td align="center" colspan="4"   bgcolor="#DCDCDC" >` + dados[1].disciplina + `</td>
                <td align="center" colspan="4"   bgcolor="#DCDCDC" >` + dados[2].disciplina + `</td>
               <td align="center" colspan="4"   bgcolor="#DCDCDC" >` + dados[3].disciplina + `</td>
               <td align="center" colspan="4"  bgcolor="#DCDCDC" >` + dados[4].disciplina + `</td>
               <td align="center" colspan="4"   bgcolor="#DCDCDC" >` + dados[5].disciplina + `</td>
                <td align="center" colspan="4"   bgcolor="#DCDCDC" >` + dados[6].disciplina + `</td>
               <td align="center" colspan="4"   bgcolor="#DCDCDC" >` + dados[7].disciplina + `</td>
                <td align="center" colspan="4"   bgcolor="#DCDCDC" >` + dados[8].disciplina + `</td>
               <td align="center" colspan="4"   bgcolor="#DCDCDC" >` + dados[9].disciplina + `</td>
               <td align="center" colspan="4"  bgcolor="#DCDCDC" >` + dados[10].disciplina + `</td>
               <td align="center" colspan="4"   bgcolor="#DCDCDC" >` + dados[11].disciplina + `</td>
  </tr>
      <tr class="heading">
            <td align="center" height="40"  width="30">
                       MD
                    </td>
                    <td align="center" height="40"  width="30">
                      P1
                    </td>
                    <td align="center" height="40"  width="30">
                       P2
                    </td>
                   <td align="center" height="40"  width="30">
                       MAC
                    </td>
                    <td align="center" height="40"  width="30">
                       MD
                    </td>
                    <td align="center" height="40"  width="30">
                      P1
                    </td>
                    <td align="center" height="40"  width="30">
                       P2
                    </td>
                   <td align="center" height="40"  width="30">
                       MAC
                    </td>
                    <td align="center" height="40"  width="30">
                       MD
                    </td>
                    <td align="center" height="40"  width="30">
                      P1
                    </td>
                    <td align="center" height="40"  width="30">
                       P2
                    </td>
                   <td align="center" height="40"  width="30">
                       MAC
                    </td>
                    <td align="center" height="40"  width="30">
                       MD
                    </td>
                    <td align="center" height="40"  width="30">
                      P1
                    </td>
                    <td align="center" height="40"  width="30">
                       P2
                    </td>
                   <td align="center" height="40"  width="30">
                       MAC
                    </td>
                     <td align="center" height="40"  width="30">
                       MD
                    </td>
                    <td align="center" height="40"  width="30">
                      P1
                    </td>
                    <td align="center" height="40"  width="30">
                       P2
                    </td>
                   <td align="center" height="40"  width="30">
                       MAC
                    </td>
                    <td align="center" height="40"  width="30">
                       MD
                    </td>
                    <td align="center" height="40"  width="30">
                      P1
                    </td>
                    <td align="center" height="40"  width="30">
                       P2
                    </td>
                   <td align="center" height="40"  width="30">
                       MAC
                    </td>
                    <td align="center" height="40"  width="30">
                       MD
                    </td>
                    <td align="center" height="40"  width="30">
                      P1
                    </td>
                    <td align="center" height="40"  width="30">
                       P2
                    </td>
                   <td align="center" height="40"  width="30">
                       MAC
                    </td>
                    <td align="center" height="40"  width="30">
                       MD
                    </td>
                    <td align="center" height="40"  width="30">
                      P1
                    </td>
                    <td align="center" height="40"  width="30">
                       P2
                    </td>
                   <td align="center" height="40"  width="30">
                       MAC
                    </td>
                    <td align="center" height="40"  width="30">
                       MD
                    </td>
                    <td align="center" height="40"  width="30">
                      P1
                    </td>
                    <td align="center" height="40"  width="30">
                       P2
                    </td>
                   <td align="center" height="40"  width="30">
                       MAC
                    </td>
                    <td align="center" height="40"  width="30">
                       MD
                    </td>
                    <td align="center" height="40"  width="30">
                      P1
                    </td>
                    <td align="center" height="40"  width="30">
                       P2
                    </td>
                   <td align="center" height="40"  width="30">
                       MAC
                    </td>
                    <td align="center" height="40"  width="30">
                       MD
                    </td>
                    <td align="center" height="40"  width="30">
                      P1
                    </td>
                    <td align="center" height="40"  width="30">
                       P2
                    </td>
                   <td align="center" height="40"  width="30">
                       MAC
                    </td> 
                    <td align="center" height="40"  width="30">
                       MD
                    </td>
                    <td align="center" height="40"  width="30">
                      P1
                    </td>
                    <td align="center" height="40"  width="30">
                       P2
                    </td>
                   <td align="center" height="40"  width="30">
                       MAC
                    </td> 
                                  
                </tr>
               </thead>
               ` + htmlDasNotas + `
                </table>
          </div>
      
          <br>
          <table width="100%" cellspacing="0" >
<tr class="footer">
    <td>` + pautaTrimestralConfiguracoes[1].valor + `</td>
    <td> ` + help.presente_data() + `</td>
    <td> ` + pautaTrimestralConfiguracoes[2].valor + ` </td>
   <tr class="footer">
       <td>_____________________________________________________</td>
       <td></td>
       <td>_____________________________________________________</td>

       </tr>
         </table>
    </body>
</html>`
      this.pautasgerarpdf(options)
    },
    isNull (notaPauta) {
      if (notaPauta) { return notaPauta } else return ''
    },
    async carregarConfiguracoesReports () {
      try {
        let msg = await axios
          .post('/configuracoes', { empresa: 'report_Pauta' })
          .then(res => res.data)
        // console.log(msg)
        if (msg.length > 0) {
          this.configuracoesReport = msg
        }
      } catch (error) {

      }
    }

  }
}
</script>
